export default __webpack_public_path__ + "static/media/step4.a42e7813.png";